import { Action, createReducer, on } from '@ngrx/store';
import { AgingPeriodActions } from '../actions';
import { AgingPeriodStates } from '../states';
import { initialState } from '../states/aging-period.states';

export const agingPeriodFeatureKey = 'agingPeriod';

export const agingPeriodReducer = createReducer(
    initialState,
    on(AgingPeriodActions.deleteLine, (state, action) => {
      if (!action.line || !action.line.guid) {
        return {
          ...state,
          lines: state.lines.filter(line => line.guid !== action.line.guid)
        };
      }
      const existingLineIndex = state.lines.findIndex(line => line.guid === action.line.guid);

      if (existingLineIndex > -1) {
        // If the line exists, update the status to 'DELETE'
        const updatedLines = [...state.lines];
        updatedLines[existingLineIndex] = { ...updatedLines[existingLineIndex], status: 'DELETED' };
        return { ...state, lines: updatedLines };
      } else {
        // If the line doesn't exist, remove it from the list
        const updatedLines = state.lines.filter(line => line.guid !== action.line.guid);
        return { ...state, lines: updatedLines };
      }
    }),
    on(AgingPeriodActions.addLine, (state, action) => ({
      ...state,
      lines: [...state.lines, action.line],
    })),
    on(AgingPeriodActions.selectAgingPeriodSuccess, (state, action) =>
      ({...state, selectedAgingPeriod: action.container.bl_fi_aging_period_hdr,
        lines: action.container.bl_fi_aging_period_line
      })),
)

export function aging_period_reducer(state: AgingPeriodStates | undefined, action: Action) {
    return agingPeriodReducer(state.agingPeriod, action);
}
